import commonStyles from "../../styles/common.module.css";
import { useApiError } from "../../provider/ApiErrorProvider";
import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL, SUPPORT_PHONE } from "../../config";

interface ErrorProps {
  errorMessage: string | null;
}

const Error = ({ errorMessage }: ErrorProps) => {
  const { actions } = useApiError();
  const {t} = useTranslation();
  return (
    <div className={commonStyles.errorContainer}>
      {/*
        Either a locale key, which translates, or a sentence the BFF already wrote,
        which i18next echoes back unchanged. The old guard here mapped the literal
        string "undefined" to a generic message — a symptom of handleApiError
        reading a field nothing sends, fixed at the source.
      */}
      <div className={commonStyles.errorMessage}>{t(`${errorMessage}`)}</div>
      <div>
        <button className={commonStyles.errorButton}
          onClick={() => {
            if (actions.retry) {
              actions.retry();
            }
          }}> 
          {t('button.tryagain')}
        </button>
      </div>
      <p className={commonStyles.errorContactInfo}>
        {t('apierror.contact.description1')} {" "}
        <a href={`mailto:${SUPPORT_EMAIL}`} className={commonStyles.link}>{SUPPORT_EMAIL}</a>
        {SUPPORT_PHONE && (
          <>
            <br></br>
            ({t('or')})
            <br></br>
            {t('apierror.contact.description2')} {" "}
            <a href={`tel:${SUPPORT_PHONE.replace(/[^+\d]/g, "")}`} className={commonStyles.link}> {SUPPORT_PHONE} </a>
          </>
        )}
      </p>
    </div>
  );
};

export default Error;
